module.exports = __webpack_public_path__ + "10e0e07cdc6289037efd92dafa315f92.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_0_0.ttf
// module id = 2244
// module chunks = 2